import React from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import breakpoints from 'utils/breakpoints';

const Container = styled.div`
  @media ${breakpoints.md} {
    height: 4.375rem;
  }
  & > * {
    height: 100%;
  }
  & > *:first-child  {
    border-top-left-radius: 0.625rem;
    border-bottom-left-radius: 0.625rem;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  & > *:last-child  {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-top-right-radius: 0.625rem;
    border-bottom-right-radius: 0.625rem;
  }
`;

const InputGroup = ({ children, className, ...rest }) => (
  <Container {...rest} className={cx('flex w-full h-60-mattamy', className)}>
    {children}
  </Container>
);

InputGroup.propTypes = {
  className: PropTypes.string,
};

export default InputGroup;
